import { Routes } from '@angular/router';
import { LoginPage } from './login.component';

export const login: Routes = [
  {
    path: 'login',
    component: LoginPage,
    title: 'Inicia Sesión',
  },
];
